import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import RefreshIcon from '@mui/icons-material/Refresh';

const PREFIX = 'MailingToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },
}));

const MailingToolbar = props => {
  const { className, meetupId, refresh, ...rest } = props;

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <RouterLink to={'/m/' + meetupId + '/mailing/add'}>
          <Button color='primary' variant='contained' style={{ marginTop: '3px' }}>
            Добавить рассылку
          </Button>
        </RouterLink>

        <Fab size='small' style={{ marginLeft: '16px' }} onClick={refresh}>
          <RefreshIcon />
        </Fab>
      </div>
    </Root>
  );
};

MailingToolbar.propTypes = {
  className: PropTypes.string,
  meetupId: PropTypes.string,
};

export default MailingToolbar;
